import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthContextProvider from "./components/context/AuthContext/AuthContext";
import { AccountContextProvider } from "./components/context/AccountContext/AccountContext";
import { TransactionContextProvider } from "./components/context/TransactionContext/TransactionsContext";
import { BrowserRouter } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthContextProvider>
      <AccountContextProvider>
        <TransactionContextProvider>
          <Navbar />
          <App />
        </TransactionContextProvider>
      </AccountContextProvider>
    </AuthContextProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
